export const USER_NOTIFICATIONS_MODAL_LIST = "USER_NOTIFICATIONS_MODAL_LIST"
export const USER_NOTIFICATIONS_MODAL_LIST_SUCCESS = "USER_NOTIFICATIONS_MODAL_LIST_SUCCESS"
export const USER_NOTIFICATIONS_MODAL_LIST_ERROR = "USER_NOTIFICATIONS_MODAL_LIST_ERROR"
